export function normalizeDinnerSearch(value: string) {
  return value
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, "");
}

export function dinnerNameMatches(name: string, query: string) {
  const candidate = normalizeDinnerSearch(name);
  const search = normalizeDinnerSearch(query);
  if (!search) return true;
  let searchIndex = 0;
  for (const character of candidate) {
    if (character === search[searchIndex]) searchIndex += 1;
    if (searchIndex === search.length) return true;
  }
  return false;
}

export function filterDinnerMeals<T extends { name: string }>(meals: T[], query: string) {
  return meals.filter(meal => dinnerNameMatches(meal.name, query));
}
